module.exports = __webpack_public_path__ + "img/TORBA5.e57eab69.jpg";